import {BaseService} from "./base.service";

class ReasonForAttentionService extends BaseService {
    constructor() {
        super('api/reason-for-attentions');
    }
}

export const reasonForAttentionsService = new ReasonForAttentionService();
